// @flow

import editLeagueSeason from './editSeason'
import deleteSeason from './deleteSeason'

export default [
  ...editLeagueSeason,
  ...deleteSeason,
]
